import * as pdfjsLib from 'pdfjs-dist/webpack.mjs'

// Copy the buffer because pdf.js transfers and consumes its input.
export function openPdf(arrayBuffer) {
  return pdfjsLib.getDocument({ data: arrayBuffer.slice(0), isEvalSupported: false }).promise
}

export default { openPdf }
